import React from 'react';
import { Row, Col } from 'react-bootstrap'; 

import Password from './password';
import MFA from './mfa';
import UserInfo from './userInfo';

const Moncompte = () => {
    return(<>
        <Row>
			<Col md={8}>
				<UserInfo />
			</Col>
			<Col md={4}>
                <Password />
                <MFA />
            </Col>
		</Row>
    </>);
}

Moncompte.propTypes = {};

export default Moncompte;